import zeusSdk from '_/utils/SDKs';

export interface IAlarmGroupIntegration {
  id: string;
  integrationId: string;
  groupId: string;
  name?: string; // Integration name from API response
}

export interface ICreateAlarmGroupIntegrationDTO {
  groupId: string;
  integrationId: string;
}

/**
 * Fetch all integrations linked to an alarm group
 */
export const requestAlarmGroupIntegrations = async (alarmGroupId: string): Promise<IAlarmGroupIntegration[]> => {
  try {
    const response = await zeusSdk.alarmGroups.getAllChildren(alarmGroupId, 'integrations');
    return response || [];
  } catch (error) {
    console.error('Error fetching alarm group integrations', error);
    return [];
  }
};

/**
 * Link an integration to an alarm group
 */
export const linkIntegrationToAlarmGroup = async (dto: ICreateAlarmGroupIntegrationDTO): Promise<IAlarmGroupIntegration> => {
  return zeusSdk.alarmGroupIntegrations.create(dto);
};

/**
 * Unlink an integration from an alarm group
 */
export const unlinkIntegrationFromAlarmGroup = async (alarmGroupIntegrationId: string): Promise<void> => {
  await zeusSdk.alarmGroupIntegrations.delete(alarmGroupIntegrationId);
};
